import React, { type JSX } from 'react';
import Button from 'components/DesignSystem/Button';

export default function DeleteButton({
  warningTitle,
  onConfirm,
  setConfirmationDialogBox,
}: {
  warningTitle: string,
  onConfirm: () => void,
  setConfirmationDialogBox: (open: boolean, body: JSX.Element, onConfirm: () => void) => void,
}) {
  const openConfirmationModal = () => {
    setConfirmationDialogBox(
      true,
      (
        <span>
          Deseja realmente remover o aviso
          <span className="fw-bold ms-1">{warningTitle}</span>
          ?
        </span>
      ),
      onConfirm,
    );
  };

  return (
    <Button
      small
      icon="trash"
      onClick={() => openConfirmationModal()}
    />
  );
}
